

import React, { useState } from 'react';
import { Container, Card, CardBody, Table, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHospital, faEye, faTimes } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import bhi1 from "./../../assets/ECHS/Bhiwani/1.jpeg";
import bhi2 from "./../../assets/ECHS/Bhiwani/2.jpeg";
import cd1 from "./../../assets/ECHS/Charkhi Dadri/1.jpeg";
import fa1 from "./../../assets/ECHS/Fatehabad/1.jpg";
import ga1 from "./../../assets/ECHS/Gurugram/1.jpeg";
import ga2 from "./../../assets/ECHS/Gurugram/2.jpeg";
import ji1 from "./../../assets/ECHS/Jind/1.jpg";
import ji2 from "./../../assets/ECHS/Jind/2.jpg";
import ku1 from "./../../assets/ECHS/Kurukshetra/1.JPG";
import pa1 from "./../../assets/ECHS/Palwal/1.jpeg";
import pn1 from "./../../assets/ECHS/Panipat/1.JPG";

const data=[
  { location: 'Bhiwani', address: 'ECHS Polyclinic, House No. 126 (Raja House) Vijay Nagar, Bhiwani-127021', images: [bhi1,bhi2] },
  { location: 'Charkhi Dadri', address: 'ECHS Polyclinic, House No. 200, Ward No. 7, Near Braham Kumari Aashram, Rohtak Road, Charkhi Dadri-127306', images: [cd1] },
  { location: 'Fatehabad', address: 'ECHS Polyclinic, 134/19, Ratia Gate, Opp Gopi Ram Dharamshala,Fatehabad – 125050', images: [fa1] },
  { location: 'Gurugram', address: ' (a) ECHS Polyclinic,  Near IDPL Township, Sector-22A,  Sector-19, Electronic City,  Gurugram-122008  (b) ECHS Polyclinic,  SF-06, Badshahpur Sohna Rd,  Sispal Vihar, Sector-49,  Gurugram-122018', images: [ga1,ga2] },
  { location: 'Jind', address: 'ECHS Polyclinic, Rajwaha Road, Gandhi Nagar Scheme No. 5, Jind -126102', images: [ji1,ji2] },
  { location: 'Kurukshetra', address: 'ECHS Polyclinic, Site No.-3, Sector-5, (Opp Sec-5 Market), Kurukshetra-136118', images: [ku1] },
  { location: 'Sirsa', address: 'ECHS Polyclinic, Air Force Station Sirsa, Dabwali Road, Sirsa', images: [] },
  { location: 'Palwal', address: 'ECHS Polyclinic, Nagla Lakhi Singh, By Pass Road, Sector-19, Near HUDA Chowk, Palwal – 121102', images: [pa1] },
  { location: 'Panipat', address: 'ECHS Polyclinic, Sewah Kheri Nangal, Panipat – 132108', images: [pn1] },
  { location: 'Rohtak', address: 'ECHS Polyclinic, House No. 887/29, Kamal Colony, Rohtak – 124001', images: [] },

  { location: 'Panchkula', address: 'ECHS Polyclinic, Command Hospital, Chandimandir, Panchkula – 134109', images: [] },

  { location: 'Jhajjar', address: 'ECHS Polyclinic, Adarsh Nagar, House No. 460/15, Jhajjar-124103', images: [] },
  { location: 'Faridabad', address: 'ECHS Polyclinic, CGO Complex NH-4, Opposite Kendriya Vidyalaya, Street No. 1, Faridabad-121001', images: [] },

  { location: 'Sonipat', address: 'ECHS Polyclinic, Jatwara, Jahri Road, Near Sugar Mill, Sonipat-131001', images: [] },
  { location: 'Kaithal', address: 'ECHS Polyclinic, HUDA Sector-19, Part -1, Kaithal – 136027', images: [] },
  { location: 'Yamuna Nagar', address: 'ECHS Polyclinic, Army Convoy Ground Jagadhri, Jagadhri-135003', images: [] },
  { location: 'Karnal', address: 'ECHS Polyclinic, Adjoining Shopping Complex, Sector-5, Urban state, Karnal – 132001', images: [] },
  { location: 'Hisar', address: 'ECHS Polyclinic, Hisar Cantt – 125006', images: [] },
  { location: 'Ambala', address: 'ECHS Polyclinic, 2 CGSR, Jagadhri Road, Ambala Cantt.-133001', images: [] },
  { location: 'Mahendergarh', address: '(a) ECHS Polyclinic,  Kanina Road Mazra Chungi,  Mahendergarh-123029 (b) ECHS Narnaul,  Neerpur,  Narnaul-123001', images: [] },
  { location: 'Rewari', address: 'ECHS Polyclinic, 169 Krishna Nagar, Garhi Bolni Road, Rewari-123401', images: [] },

]

const Echs = () => {
  const [modalShow, setModalShow] = useState(false);
  const [selectedCanteen, setSelectedCanteen] = useState(null);
    
  const handleShowModal = (echs) => {
    setSelectedCanteen(echs);
    setModalShow(true);
  };
    
  const handleCloseModal = () => {
    setModalShow(false);
    setSelectedCanteen(null);
  };
  
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faHospital} className="me-2" />
            ECHS Polyclinics
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faHospital} className="me-2" />
              ECHS Polyclinic Directory
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="table-responsive">
              <Table bordered hover className="mb-0">
                <thead>
                  <tr>
                    <th style={{ background: '#1e3c72', color: 'white', width: '8%' }}>S.No.</th>
                    <th style={{ background: '#1e3c72', color: 'white', width: '15%' }}>District</th>
                    <th style={{ background: '#1e3c72', color: 'white', width: '57%' }}>Address</th>
                    <th style={{ background: '#1e3c72', color: 'white', width: '20%' }}>Images</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={index}>
                      <td style={{ color: '#495057' }}>{index + 1}</td>
                      <td style={{ color: '#1e3c72', fontWeight: '600' }}>{item.location}</td>
                      <td style={{ color: '#495057', wordWrap: 'break-word', wordBreak: 'break-word', whiteSpace: 'normal' }}>
                        {item.address.split('(b)').map((part, i, arr) => (
                          <div key={i}>
                            {i > 0 ? '(b)' : ''}{part}
                            {i < arr.length - 1 && <br />}
                          </div>
                        ))}
                      </td>
                      <td className="text-center">
                        {item.images.length !== 0 ? (
                          <Button 
                            style={{
                              background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                              border: 'none',
                              borderRadius: '20px',
                              padding: '6px 15px',
                              fontSize: '14px',
                              fontWeight: '600',
                              width: window.innerWidth < 768 ? '100%' : '40%'
                            }}
                            onClick={() => handleShowModal(item)}
                            onMouseOver={(e) => {
                              e.currentTarget.style.background = 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)';
                              e.currentTarget.style.transform = 'scale(1.05)';
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.background = 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)';
                              e.currentTarget.style.transform = 'scale(1)';
                            }}
                          >
                            <FontAwesomeIcon icon={faEye} className="me-2" />
                            View
                          </Button>
                        ) : (
                          <span style={{ color: '#6c757d' }}>-</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Container>
        {selectedCanteen && (
          <Modal isOpen={modalShow} toggle={handleCloseModal} size="lg" centered>
            <ModalHeader 
              toggle={handleCloseModal}
              style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white',
                border: 'none'
              }}
            >
              <FontAwesomeIcon icon={faHospital} className="me-2" />
              ECHS <span style={{color: '#fff'}}>{selectedCanteen.location}</span> Images
            </ModalHeader>
            <ModalBody className="p-0">
              <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                  {selectedCanteen.images.map((_, idx) => (
                    <button
                      key={idx}
                      type="button"
                      data-bs-target="#carouselExampleAutoplaying"
                      data-bs-slide-to={idx}
                      className={idx === 0 ? 'active' : ''}
                      style={{
                        backgroundColor: idx === 0 ? '#1e3c72' : '#6c757d',
                        border: 'none',
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        margin: '0 5px'
                      }}
                      aria-current={idx === 0 ? 'true' : 'false'}
                      aria-label={`Slide ${idx + 1}`}
                    ></button>
                  ))}
                </div>
                <div className="carousel-inner">
                  {selectedCanteen.images.map((image, index) => (
                    <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                      <img 
                        src={image} 
                        className="d-block mx-auto" 
                        alt={`image-${index}`} 
                        style={{
                          height: '350px',
                          width: 'auto',
                          maxWidth: '100%',
                          objectFit: 'contain'
                        }}
                      />
                    </div>
                  ))}
                </div>
                <button 
                  className="carousel-control-prev" 
                  type="button" 
                  data-bs-target="#carouselExampleAutoplaying" 
                  data-bs-slide="prev"
                  style={{ opacity: '0.8' }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button 
                  className="carousel-control-next" 
                  type="button" 
                  data-bs-target="#carouselExampleAutoplaying" 
                  data-bs-slide="next"
                  style={{ opacity: '0.8' }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </ModalBody>
            <ModalFooter style={{ borderTop: '1px solid #e9ecef', background: '#f8f9fa' }}>
              <Button
                style={{
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '10px 25px',
                  fontWeight: '600'
                }}
                onClick={handleCloseModal}
              >
                <FontAwesomeIcon icon={faTimes} className="me-2" />
                Close
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </>
    );
};

export default Echs;
